/**
 * Araya Custom Box Builder
 * Wizard de 3 pasos: tamano -> color -> chocolates.
 * Vanilla JS, sin frameworks. Mobile-first.
 *
 * Mount: el section/template renderiza un <div id="byb-root" data-...> con:
 *   data-byb-variants    JSON {"9":<variant_id>, "12":<variant_id>, ...}
 *   data-byb-prices      JSON {"9":15000, "12":19000, ...}
 *   data-byb-csv-url     URL del Google Sheet publicado como CSV (opcional)
 *   data-byb-fallback    URL del JSON dummy embebido en el tema (asset)
 *   data-byb-color-images JSON {"rojo":"https://...", "blanco":"...", "marron":"..."}
 *   data-byb-currency    string "CLP" / "USD" / etc.
 *   data-byb-cart-route  string "/cart/add.js" (Symmetry expone window.routes.cart_add_url tambien)
 */
(function () {
  'use strict';

  var DRAFT_KEY = 'araya-box-draft';
  // 2026-10-02: clave subida porque Venezuela 41% volvio a tener stock (antes araya-catalog-cache-v5).
  // 2026-10-13: clave subida porque Coconut Almonds quedo agotado (antes araya-catalog-cache-v5b).
  var CATALOG_KEY = 'araya-catalog-cache-v6b'; // v4: Venezuela 41% fuera de catalogo (2026-08-23). El bump descarta el cache de 6h que aun servia el sabor retirado a quien ya habia abierto el builder.
  var CATALOG_TTL_MS = 6 * 60 * 60 * 1000; // 6h prod
  var SIZES = [9, 12, 18, 27, 36, 50];
  var COLORS = [
    { id: 'red', label: 'Red' },
    { id: 'white', label: 'White' },
    { id: 'brown', label: 'Brown' }
  ];
  // Foto real de la caja por TAMAÑO × COLOR (Shopify CDN, width 600 para thumbnails).
  // El selector del paso 2 muestra la imagen que corresponde al size elegido.
  var IMG = 'https://arayachocolate.com/cdn/shop/products/';
  var COLOR_IMAGES_BY_SIZE = {
    9:  { white: IMG + 'Araya0073.jpg?v=1751909561&width=450', red: IMG + 'Araya0186.jpg?v=1751909561&width=450', brown: IMG + 'Araya0279.jpg?v=1664118949&width=450' },
    12: { white: IMG + 'Araya0108.jpg?v=1664119234&width=450', red: IMG + 'Araya0184.jpg?v=1664119235&width=450', brown: IMG + 'Araya0277.jpg?v=1664119234&width=450' },
    18: { white: IMG + 'Araya0113.jpg?v=1664119556&width=450', red: IMG + 'Araya0181.jpg?v=1664119556&width=450', brown: IMG + 'Araya0268.jpg?v=1664119556&width=450' },
    27: { white: IMG + 'Araya0131.jpg?v=1664120155&width=450', red: IMG + 'Araya0207.jpg?v=1664120155&width=450', brown: IMG + 'Araya0251.jpg?v=1664120155&width=450' },
    36: { white: IMG + 'Araya0136.jpg?v=1664120508&width=450', red: IMG + 'Araya0200.jpg?v=1664120507&width=450', brown: IMG + 'Araya0256.jpg?v=1664120507&width=450' },
    50: { white: IMG + 'Araya0140.jpg?v=1664122180&width=450', red: IMG + 'Araya0189.jpg?v=1664122180&width=450', brown: IMG + 'Araya0274.jpg?v=1664122180&width=450' }
  };
  var TAG_LABELS = {
    fruit: 'Fruit',
    nuts: 'Nuts',
    alcohol: 'Alcohol',
    coffee: 'Coffee',
    vegan: 'Vegan',
    spicy: 'Spicy',
    tea: 'Tea',
    caramel: 'Caramel',
    salt: 'Salt',
    best_seller: 'Best Seller',
    new: 'New'
  };
  var TYPE_LABELS = { dark: 'Dark', milk: 'Milk', white: 'White' };
  // Tipo doble (cobertura+relleno): types = ["milk","dark"] → label "Milk & Dark"; filtro por pertenencia.
  function typesOf(item) {
    if (Array.isArray(item.types) && item.types.length) return item.types;
    return String(item.type || '').split(/[ ,]+/).map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
  }
  function typeLabel(item) { return typesOf(item).map(function (t) { return TYPE_LABELS[t] || t; }).join(' & '); }
  // #1/#13: opciones de Include — ampliadas. Exclude usa la MISMA lista (espejo).
  var FLAVOR_FILTERS = [
    { id: 'fruit', label: 'Fruit' }, { id: 'nuts', label: 'Nuts' },
    { id: 'alcohol', label: 'Alcohol' }, { id: 'coffee', label: 'Coffee' },
    { id: 'spicy', label: 'Spicy' }, { id: 'tea', label: 'Tea' },
    { id: 'caramel', label: 'Caramel' }, { id: 'vegan', label: 'Vegan' }
  ];

  // ---------- State ----------
  var state = {
    step: 1,
    size: null,
    color: null,
    items: [], // [{id, qty}]
    boxId: null,
    editLineKey: null, // line key de la caja original en edición (L4)
    filters: {
      category: 'all', // all | chocolate | truffle (#12)
      sort: '',        // '' | cal-asc | cal-desc (#1)
      search: '',      // búsqueda por nombre / tag / descripción
      types: [],
      include: [],
      exclude: []
    }
  };

  var catalog = []; // [{id, name, description, type, tags, image_url, sort_order, active}]
  var root, cfg;
  var panelExpanded = false; // mobile bottom-sheet expansion state
  var filtersOpen = false;   // mobile: filtros colapsados por defecto (menos scroll al elegir)
  var adding = false;        // C1: guard contra doble-submit de add-to-cart
  var helpExpanded = false;  // "How it works" SIEMPRE colapsado por defecto (nunca abierto)
  var helpHidden = false;    // "Don't show again" → persiste en localStorage

  // ---------- Init ----------
  function init() {
    root = document.getElementById('byb-root');
    if (!root) return;

    cfg = {
      variants: safeJSON(root.dataset.bybVariants, {}),
      prices: safeJSON(root.dataset.bybPrices, {}),
      colorImages: safeJSON(root.dataset.bybColorImages, {}),
      inlineCatalog: (function () {
        var el = document.querySelector('[data-byb-catalog]');
        if (!el) return null;
        try { var j = JSON.parse(el.textContent); return j.chocolates || j; } catch (e) { return null; }
      })(),
      csvUrl: root.dataset.bybCsvUrl || '',
      fallbackUrl: root.dataset.bybFallback || '',
      currency: root.dataset.bybCurrency || 'CLP',
      cartRoute: root.dataset.bybCartRoute || (window.routes && window.routes.cart_add_url) || '/cart/add.js'
    };

    try { helpHidden = localStorage.getItem('araya-byb-help-hidden') === '1'; } catch (e) {}
    restoreDraft();
    renderShell();
    bindEvents();
    loadCatalog()
      .then(function () { return maybeHydrateEdit(); })
      .then(function () { pruneInvalidItems(); render(); });
  }

  // ---------- Catalog ----------
  function loadCatalog() {
    var forceRefresh = new URLSearchParams(window.location.search).get('refresh') === '1';
    // Prioridad 1: catálogo inline server-rendered desde metaobjects (siempre fresco, con fotos nuevas).
    if (cfg.inlineCatalog && cfg.inlineCatalog.length) {
      catalog = cfg.inlineCatalog.filter(function (c) { return c.active !== false; });
      persistCatalog();
      return Promise.resolve();
    }
    if (!forceRefresh) {
      try {
        var raw = localStorage.getItem(CATALOG_KEY);
        if (raw) {
          var cached = JSON.parse(raw);
          if (cached && cached.ts && (Date.now() - cached.ts) < CATALOG_TTL_MS && Array.isArray(cached.data)) {
            catalog = cached.data.filter(function (c) { return c.active !== false; });
            return Promise.resolve();
          }
        }
      } catch (e) { /* ignore */ }
    }
    if (cfg.csvUrl) {
      return fetch(cfg.csvUrl)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          catalog = parseCSV(text);
          persistCatalog();
        })
        .catch(function () { return loadFallback(); });
    }
    return loadFallback();
  }

  function loadFallback() {
    if (!cfg.fallbackUrl) {
      catalog = [];
      return Promise.resolve();
    }
    return fetch(cfg.fallbackUrl)
      .then(function (r) { return r.json(); })
      .then(function (j) {
        catalog = (j.chocolates || []).filter(function (c) { return c.active !== false; });
        persistCatalog();
      })
      .catch(function () { catalog = []; });
  }

  function parseCSV(text) {
    var lines = text.split(/\r?\n/).filter(Boolean);
    if (lines.length < 2) return [];
    var headers = splitCSVLine(lines[0]).map(function (h) { return h.trim(); });
    var out = [];
    for (var i = 1; i < lines.length; i++) {
      var cells = splitCSVLine(lines[i]);
      if (!cells.length) continue;
      var obj = {};
      headers.forEach(function (h, idx) { obj[h] = (cells[idx] || '').trim(); });
      if (obj.active && obj.active.toLowerCase() === 'false') continue;
      out.push({
        id: obj.id,
        name: obj.name,
        description: obj.description || '',
        type: (obj.type || '').toLowerCase(),
        tags: (obj.tags || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean),
        image_url: obj.image_url || '',
        calories: obj.calories ? parseInt(obj.calories, 10) : null,
        category: (obj.category || 'chocolate').toLowerCase(),
        sort_order: parseInt(obj.sort_order || '0', 10),
        active: true
      });
    }
    out.sort(function (a, b) { return (a.sort_order || 0) - (b.sort_order || 0); });
    return out;
  }

  function splitCSVLine(line) {
    var result = [], cur = '', inQuotes = false;
    for (var i = 0; i < line.length; i++) {
      var ch = line[i];
      if (ch === '"' && line[i + 1] === '"') { cur += '"'; i++; }
      else if (ch === '"') { inQuotes = !inQuotes; }
      else if (ch === ',' && !inQuotes) { result.push(cur); cur = ''; }
      else { cur += ch; }
    }
    result.push(cur);
    return result;
  }

  function persistCatalog() {
    try {
      localStorage.setItem(CATALOG_KEY, JSON.stringify({ ts: Date.now(), data: catalog }));
    } catch (e) { /* ignore quota */ }
  }

  // ---------- Draft persistence ----------
  function restoreDraft() {
    try {
      var raw = localStorage.getItem(DRAFT_KEY);
      if (!raw) { state.boxId = uuid(); return; }
      var d = JSON.parse(raw);
      if (d && typeof d === 'object') {
        state.size = (SIZES.indexOf(d.size) >= 0) ? d.size : null;
        state.color = colorIsValid(d.color) ? d.color : null;
        state.items = sanitizeItems(d.items);
        state.boxId = d.boxId || uuid();
        state.step = state.size && state.color ? 3 : (state.size ? 2 : 1);
      }
    } catch (e) { state.boxId = uuid(); }
  }

  function persistDraft() {
    try {
      localStorage.setItem(DRAFT_KEY, JSON.stringify({
        size: state.size,
        color: state.color,
        items: state.items,
        boxId: state.boxId,
        updated_at: Date.now()
      }));
    } catch (e) { /* ignore */ }
  }

  function clearDraft() {
    try { localStorage.removeItem(DRAFT_KEY); } catch (e) {}
    state = { step: 1, size: null, color: null, items: [], boxId: uuid(), editLineKey: null, deliverBy: '',
      filters: { category: 'all', sort: '', search: '', types: [], include: [], exclude: [] } };
  }

  // L4 fix: la edición carga la caja desde el CARRITO REAL (/cart.js) por _box_id
  // — no depende solo de localStorage (resiste incógnito/ITP/otra pestaña). La
  // línea original NO se borró al hacer clic en "Edit box"; se elimina por su
  // line-key solo tras un re-add exitoso (ver onAddToCart). Corre tras cargar el
  // catálogo para poder validar los chocolates contra el surtido vivo.
  function maybeHydrateEdit() {
    var editId = new URLSearchParams(window.location.search).get('edit');
    if (!editId) return Promise.resolve();
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        var line = cart && cart.items && cart.items.find(function (it) {
          return it.properties && it.properties._box_id === editId;
        });
        if (line) hydrateFromCartLine(line, editId);
        else hydrateFromLocalHint(editId);
      })
      .catch(function () { hydrateFromLocalHint(editId); });
  }

  // Re-parsea la property legible "2× Name / 1× Name" → [{id,qty}] (mapea name→id por catálogo).
  // Reemplaza al _chocolates_json: una sola property sirve para cocina Y para editar.
  // Match NORMALIZADO (trim+lower) para resistir cambios de capitalización/espacios en el
  // surtido vivo; si un sabor ya no existe, avisa cuántas piezas faltan (no se pierde en silencio).
  function parseChocolatesProp(str) {
    var out = [], missing = 0;
    if (!str) return out;
    String(str).split('/').forEach(function (part) {
      var m = part.trim().match(/^(\d+)\s*[x×]\s*(.+)$/i);
      if (!m) return;
      var qty = parseInt(m[1], 10);
      var name = normName(m[2]);
      var c = catalog.find(function (x) { return normName(x.name) === name; });
      if (c && qty > 0) out.push({ id: c.id, qty: qty });
      else if (qty > 0) missing += qty;
    });
    if (missing > 0) setTimeout(function () {
      toast('Some flavors are no longer available. Add ' + missing + ' to finish your box.');
    }, 500);
    return out;
  }

  function hydrateFromCartLine(line, editId) {
    var p = line.properties || {};
    var sizeMatch = String(p._size || p.Size || p['Tamaño'] || '').match(/(\d+)/);
    if (sizeMatch) state.size = parseInt(sizeMatch[1], 10);
    var colorRaw = String(p.Color || '').toLowerCase();
    var colorMap = { red: 'red', rojo: 'red', white: 'white', blanco: 'white', brown: 'brown', marron: 'brown', 'marrón': 'brown' };
    state.color = colorMap[colorRaw] || colorRaw || state.color;
    state.items = parseChocolatesProp(p.Chocolates); // antes: JSON.parse(_chocolates_json) — ya no hay JSON
    state.deliverBy = p['Deliver by'] || '';
    state.boxId = editId;
    state.editLineKey = line.key;   // se borra por key (robusto ante _box_id duplicado)
    state.step = 3;
    persistDraft();
  }

  function hydrateFromLocalHint(editId) {
    try {
      var pending = localStorage.getItem('araya-box-edit-pending');
      if (pending) {
        var p = JSON.parse(pending);
        state.size = p.size;
        state.color = p.color;
        state.items = Array.isArray(p.items) ? sanitizeItems(p.items) : parseChocolatesProp(p.chocolates);
        state.boxId = p.boxId || editId;
        state.step = 3;
        localStorage.removeItem('araya-box-edit-pending');
        persistDraft();
      }
    } catch (e) { /* ignore */ }
  }

  // ---------- Helpers ----------
  function uuid() {
    return 'box_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
  }
  function totalQty() {
    return state.items.reduce(function (s, it) { return s + it.qty; }, 0);
  }
  function getQty(id) {
    var it = state.items.find(function (x) { return x.id === id; });
    return it ? it.qty : 0;
  }
  function setQty(id, qty) {
    var idx = state.items.findIndex(function (x) { return x.id === id; });
    if (qty <= 0) {
      if (idx >= 0) state.items.splice(idx, 1);
    } else {
      if (idx >= 0) state.items[idx].qty = qty;
      else state.items.push({ id: id, qty: qty });
    }
    persistDraft();
  }
  function safeJSON(s, fallback) {
    if (!s) return fallback;
    try { return JSON.parse(s); } catch (e) { return fallback; }
  }
  function fmtPrice(n) {
    var v = Number(n) || 0;
    var cur = cfg.currency || 'USD';
    try {
      var hasCents = v % 1 !== 0;
      // narrowSymbol + en-US → "$48" (no "US$48", que se ve raro en una web de EE.UU.)
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: cur,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: hasCents ? 2 : 0,
        maximumFractionDigits: 2
      }).format(v);
    } catch (e) {
      return '$' + v;
    }
  }
  function chocoById(id) { return catalog.find(function (c) { return c.id === id; }); }
  function normName(s) { return String(s == null ? '' : s).trim().toLowerCase(); }
  // Normaliza para búsqueda "similar": minúsculas + sin acentos (café → cafe).
  function searchNorm(s) { return String(s == null ? '' : s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim(); }
  function colorIsValid(c) { return COLORS.some(function (x) { return x.id === c; }); }
  function cssEsc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/["\\\]]/g, '\\$&'); }
  // Seguridad: solo permite https:// (o //cdn protocol-relative, o rutas same-origin /...).
  // Bloquea javascript:/data:/http: antes de interpolar la URL en un src.
  function safeUrl(u) {
    u = String(u == null ? '' : u).trim();
    if (/^https:\/\//i.test(u)) return u;
    if (/^\/\//.test(u)) return 'https:' + u;
    if (/^\/(?!\/)/.test(u)) return u;
    return '';
  }
  // Valida shape de items de localStorage/edición: {id:string, qty:int>0}. No valida contra
  // catálogo (puede no estar cargado aún) — eso lo hace pruneInvalidItems tras loadCatalog.
  function sanitizeItems(arr) {
    if (!Array.isArray(arr)) return [];
    return arr.filter(function (it) {
      return it && typeof it.id === 'string' && it.id && typeof it.qty === 'number' && isFinite(it.qty) && it.qty > 0;
    }).map(function (it) { return { id: it.id, qty: Math.floor(it.qty) }; });
  }
  // Tras cargar el catálogo: descarta items cuyo id ya no existe (evita contar piezas
  // fantasma y mandar ids crudos a la cocina) y recorta al tope del tamaño. Re-persiste si cambió.
  function pruneInvalidItems() {
    if (!catalog.length) return;
    var before = JSON.stringify(state.items);
    state.items = state.items.filter(function (it) { return chocoById(it.id); });
    if (state.size) {
      var t = totalQty();
      while (t > state.size && state.items.length) {
        var last = state.items[state.items.length - 1];
        var cut = Math.min(last.qty, t - state.size);
        last.qty -= cut; t -= cut;
        if (last.qty <= 0) state.items.pop();
      }
    }
    if (before !== JSON.stringify(state.items)) persistDraft();
  }

  // ---------- Render shell ----------
  function renderShell() {
    root.innerHTML =
      '<div class="byb">' +
        renderHelp() +
        '<div class="byb-stepper" data-byb-stepper></div>' +
        '<div class="byb-stage" data-byb-stage></div>' +
      '</div>';
  }

  // Toggle "How it works" con opción "Don't show again" (persiste en localStorage).
  function renderHelp() {
    if (helpHidden) return '';
    return '<div class="byb-help' + (helpExpanded ? ' is-open' : '') + '" data-byb-help>' +
      '<button type="button" class="byb-help__head" data-byb-help-toggle aria-expanded="' + (helpExpanded ? 'true' : 'false') + '">' +
        '<span class="byb-help__title">How to build your box</span>' +
        '<span class="byb-help__chev" aria-hidden="true"></span>' +
      '</button>' +
      '<div class="byb-help__body">' +
        '<ol class="byb-help__steps">' +
          '<li><strong>Pick your size</strong>: 9 to 50 pieces.</li>' +
          '<li><strong>Choose your box</strong>: red, white, or brown.</li>' +
          '<li><strong>Fill it with chocolates</strong>: add pieces until the box is full, then add to cart.</li>' +
        '</ol>' +
        '<button type="button" class="byb-help__dismiss" data-byb-help-dismiss>Don\'t show this again</button>' +
      '</div>' +
    '</div>';
  }
  function toggleHelp() {
    helpExpanded = !helpExpanded;
    var el = root.querySelector('[data-byb-help]');
    if (el) el.outerHTML = renderHelp();
  }
  function dismissHelp() {
    helpHidden = true;
    try { localStorage.setItem('araya-byb-help-hidden', '1'); } catch (e) {}
    var el = root.querySelector('[data-byb-help]');
    if (el && el.parentNode) el.parentNode.removeChild(el);
    // a11y: el botón que tenía el foco se eliminó → reubicar el foco al inicio del builder
    var h = root.querySelector('.byb-h2, .byb-step');
    if (h) { h.setAttribute('tabindex', '-1'); try { h.focus(); } catch (e) {} }
  }

  function render() {
    renderStepper();
    var stage = root.querySelector('[data-byb-stage]');
    if (!stage) return;
    if (state.step === 1) stage.innerHTML = renderStep1();
    else if (state.step === 2) stage.innerHTML = renderStep2();
    else stage.innerHTML = renderStep3();
  }

  function renderStepper() {
    var s = root.querySelector('[data-byb-stepper]');
    if (!s) return;
    var steps = [
      { n: 1, label: 'Size', val: state.size ? state.size + ' pieces' : '' },
      { n: 2, label: 'Color', val: state.color ? labelFor(COLORS, state.color) : '' },
      { n: 3, label: 'Chocolates', val: state.size ? totalQty() + ' / ' + state.size : '' }
    ];
    // #4: barra solo TEXTO (sin íconos/círculos numerados). Label + valor.
    s.innerHTML = steps.map(function (st) {
      var cls = 'byb-step' + (state.step === st.n ? ' is-active' : '') + (state.step > st.n ? ' is-done' : '');
      var canClick = (st.n < state.step) || (st.n === 2 && state.size) || (st.n === 3 && state.size && state.color);
      return '<button type="button" class="' + cls + '" data-byb-goto="' + st.n + '" ' + (canClick ? '' : 'disabled') + '>' +
        '<span class="byb-step__label">' + st.label + '</span>' +
        '<span class="byb-step__val">' + esc(st.val) + '</span>' +
      '</button>';
    }).join('');
  }

  function labelFor(arr, id) {
    var f = arr.find(function (x) { return x.id === id || x === id; });
    return f && f.label ? f.label : id;
  }

  // ---------- Step 1: Size ----------
  function renderStep1() {
    var html = '<h2 class="byb-h2">Choose your box size</h2>' +
      '<p class="byb-lead">Each size has a fixed price. You can change it later without losing your selection.</p>' +
      '<div class="byb-sizes">';
    SIZES.forEach(function (n) {
      var price = cfg.prices && cfg.prices[n] ? fmtPrice(cfg.prices[n]) : '';
      var sel = state.size === n ? ' is-selected' : '';
      var popular = n === 18; // #3: 18 piezas = más popular
      html += '<button type="button" class="byb-size-card' + sel + (popular ? ' is-popular' : '') + '" data-byb-size="' + n + '" aria-pressed="' + (state.size === n ? 'true' : 'false') + '">' +
        (popular ? '<span class="byb-size-card__badge">Most popular</span>' : '') +
        '<div class="byb-size-card__count">' + n + '</div>' +
        '<div class="byb-size-card__label">pieces</div>' +
        (price ? '<div class="byb-size-card__price">' + price + '</div>' : '') +
      '</button>';
    });
    html += '</div>';
    return html;
  }

  // ---------- Step 2: Color ----------
  function renderStep2() {
    var sizeImgs = COLOR_IMAGES_BY_SIZE[state.size] || {};
    var html = '<h2 class="byb-h2">Choose your box</h2>' +
      '<p class="byb-lead">Only changes the packaging, not the price.</p>' +
      '<div class="byb-colors">';
    COLORS.forEach(function (c) {
      var img = sizeImgs[c.id] || cfg.colorImages[c.id] || '';
      var sel = state.color === c.id ? ' is-selected' : '';
      html += '<button type="button" class="byb-color-card' + sel + '" data-byb-color="' + c.id + '" aria-pressed="' + (state.color === c.id ? 'true' : 'false') + '">' +
        (img ? '<img class="byb-color-card__img" src="' + esc(safeUrl(img)) + '" alt="' + esc(c.label) + ' box, ' + state.size + ' pieces" loading="lazy" decoding="async">' :
               '<div class="byb-color-card__swatch byb-color-' + c.id + '"></div>') +
        '<div class="byb-color-card__label">' + c.label + '</div>' +
      '</button>';
    });
    html += '</div>' +
      '<div class="byb-actions">' +
        '<button type="button" class="byb-btn byb-btn--ghost" data-byb-back>← Change size</button>' +
      '</div>';
    return html;
  }

  // ---------- Step 3: Chocolates ----------
  function renderStep3() {
    var total = totalQty();
    var pct = state.size ? Math.min(100, Math.round((total / state.size) * 100)) : 0;
    var ctaText = ctaTextFor(total, state.size);
    var ctaDisabled = total !== state.size;

    var html =
      '<div class="byb-step3-header">' +
        '<div class="byb-progress">' +
          '<div class="byb-progress__count" aria-live="polite">' + total + '/' + state.size + ' pieces</div>' +
          '<div class="byb-progress__bar" role="progressbar" aria-valuemin="0" aria-valuemax="' + state.size + '" aria-valuenow="' + total + '" aria-label="Pieces chosen"><div class="byb-progress__fill" style="width:' + pct + '%"></div></div>' +
        '</div>' +
        '<div class="byb-actions">' +
          '<button type="button" class="byb-btn byb-btn--ghost byb-btn--sm" data-byb-back>← Back</button>' +
        '</div>' +
      '</div>' +
      renderFilters() +
      '<div class="byb-step3-body">' +
        '<div class="byb-catalog">' +
          renderCatalogSections(sortByCalories(catalog.filter(passesFilters))) +
        '</div>' +
        '<aside class="byb-selection' + (panelExpanded ? ' is-expanded' : '') + '" data-byb-selection>' +
          renderSelectionPanel() +
        '</aside>' +
      '</div>';

    return html;
  }

  function renderSelectionPanel() {
    var total = totalQty();
    var size = state.size || 0;
    var canAdd = total < size;
    var html =
      '<div class="byb-selection__head">' +
        '<button type="button" class="byb-selection__handle" data-byb-toggle-selection aria-expanded="' + (panelExpanded ? 'true' : 'false') + '">' +
          '<span class="byb-selection__title">Your selection</span>' +
          '<span class="byb-selection__count">' + total + '/' + size + '</span>' +
        '</button>' +
        '<button type="button" class="byb-clear' + (size && (total / size) >= 0.8 ? ' is-danger' : '') + '" data-byb-clear' + (total === 0 ? ' disabled' : '') + '>Clear all</button>' +
      '</div>' +
      (size && cfg.prices && cfg.prices[size] ? '<div class="byb-selection__price"><span class="byb-selection__price-label">' + size + '-piece box</span><span class="byb-selection__price-amt">' + fmtPrice(cfg.prices[size]) + '</span></div>' : '') +
      '<div class="byb-selection__body">';
    if (state.items.length === 0) {
      html += '<p class="byb-selection__empty">No pieces yet.<br>Select any image to see details, or use + on a card to add it to your box.</p>';
    } else {
      html += '<ul class="byb-selection__list">';
      state.items.forEach(function (it) {
        var c = chocoById(it.id);
        if (!c) return;
        html += '<li class="byb-sel-item">' +
          (c.image_url
            ? '<img class="byb-sel-item__img" src="' + esc(safeUrl(c.image_url)) + '" alt="" loading="lazy" decoding="async">'
            : '<div class="byb-sel-item__img byb-sel-item__img--placeholder"></div>') +
          '<span class="byb-sel-item__name">' + esc(c.name) + '</span>' +
          '<span class="byb-sel-item__controls">' +
            '<button type="button" class="byb-qty-btn byb-qty-btn--sm" data-byb-qty-dec="' + esc(it.id) + '" aria-label="Remove one">−</button>' +
            '<span class="byb-sel-item__qty">' + it.qty + '</span>' +
            '<button type="button" class="byb-qty-btn byb-qty-btn--sm" data-byb-qty-inc="' + esc(it.id) + '" ' + (canAdd ? '' : 'disabled') + ' aria-label="Add one">+</button>' +
          '</span>' +
        '</li>';
      });
      html += '</ul>';
    }
    html += '</div>'; // cierra body
    // La fecha aparece SOLO cuando la caja esta completa, arriba del boton.
    if (size > 0 && total === size) {
      html += renderDeliveryDate();
    }
    html += '<div class="byb-selection__cta">' +
      '<button type="button" class="byb-btn byb-btn--primary byb-btn--cta" data-byb-add' + (total !== size ? ' disabled' : '') + '>' + esc(ctaTextFor(total, size)) + '</button>' +
    '</div>';
    return html;
  }
  function renderDeliveryDate() {
    return '<div class="byb-selection__date">' +
      '<label class="byb-selection__date-lbl" for="byb-deliver">When do you need it? <span class="byb-selection__date-opt">(optional)</span></label>' +
      '<input type="date" id="byb-deliver" class="byb-selection__date-input" data-byb-date data-araya-date data-adp-placeholder="As soon as possible" value="' + esc(state.deliverBy || '') + '"' + (bybMinDate() ? ' min="' + bybMinDate() + '"' : '') + '>' +
    '</div>';
  }
  function bybMinDate(){ try{ var t=new Date(); t.setDate(t.getDate()+1); return t.toISOString().slice(0,10); }catch(e){ return ''; } }
  function bybIsWeekend(v){ if(!v) return false; var d=new Date(v+'T00:00:00'); return d.getDay()===0; } // domingo bloqueado

  function ctaTextFor(total, size) {
    if (!size) return 'Select a size';
    if (total === 0) return 'Start picking your chocolates';
    if (total < size) {
      var diff = size - total;
      return 'Add ' + diff + ' more';
    }
    if (total > size) return 'Remove ' + (total - size) + ' pieces';
    var price = cfg.prices && cfg.prices[size] ? ' ' + fmtPrice(cfg.prices[size]) : '';
    return 'Add to cart' + price;
  }

  // Bloque de confianza envío/pickup bajo el CTA (D1: nada de "free"). Íconos heredan
  // el color por currentColor → se pintan con la paleta del builder vía CSS.
  function renderShippingInfo() {
    var items = [
      { svg: '<rect x="10.5" y="3" width="3" height="12" rx="1.5" stroke="currentColor" stroke-width="2" fill="none"/><circle cx="12" cy="17.5" r="2.5" stroke="currentColor" stroke-width="2" fill="none"/><line x1="12" y1="9" x2="12" y2="15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>', text: 'Weather-tracked and heat-shielded shipping' },
      { svg: '<path d="M3 7h11v10H3V7zm11 4h4l3 3v3h-7v-6z" stroke="currentColor" stroke-width="2" fill="none" stroke-linejoin="round"/><path d="M7 17a2 2 0 100 4 2 2 0 000-4zm12 0a2 2 0 100 4 2 2 0 000-4z" stroke="currentColor" stroke-width="2" fill="none"/>', text: 'Local delivery within 6 miles of our stores. Order by 4 PM CST' },
      { svg: '<path d="M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" stroke="currentColor" stroke-width="2" fill="none"/>', text: 'Pickup available at any location, ready in ~2 hours' },
      { svg: '<path d="M12 2a10 10 0 100 20 10 10 0 000-20zM2 12h20M12 2s-4 4.5-4 10 4 10 4 10 4-4.5 4-10-4-10-4-10z" stroke="currentColor" stroke-width="2" fill="none"/>', text: 'Nationwide shipping available' },
      { svg: '<path d="M3 5h18v16H3V5zm4 0V2m10 3V2M3 9h18" stroke="currentColor" stroke-width="2" fill="none"/>', text: 'Future shipping date scheduling available' }
    ];
    var rows = items.map(function (it) {
      return '<span class="byb-ship-item">' +
        '<span class="byb-ship-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">' + it.svg + '</svg></span>' +
        '<span class="byb-ship-text">' + it.text + '</span>' +
      '</span>';
    }).join('');
    // Marquee: pista duplicada → loop continuo sin salto. Pausa con prefers-reduced-motion (CSS).
    return '<div class="byb-ship-info byb-ship-marquee" role="region" aria-label="Shipping and pickup">' +
      '<div class="byb-ship-track">' + rows + rows + '</div>' +
    '</div>';
  }

  function renderFilters() {
    var f = state.filters;
    function chip(group, id, label, single) {
      var on = single ? (f[group] === id) : (f[group].indexOf(id) >= 0);
      return '<button type="button" class="byb-chip' + (on ? ' is-on' : '') + '"' +
        ' aria-pressed="' + (on ? 'true' : 'false') + '"' +
        ' data-byb-filter="' + group + '" data-byb-filter-val="' + id + '"' +
        (single ? ' data-byb-single="1"' : '') + '>' + label + '</button>';
    }
    function group(label, chipsHtml, extraCls) {
      return '<div class="byb-filter-group' + (extraCls ? ' ' + extraCls : '') + '">' +
        '<div class="byb-filter-group__label">' + label + '</div>' +
        '<div class="byb-filter-group__chips">' + chipsHtml + '</div>' +
      '</div>';
    }
    var out = '<div class="byb-filters' + (filtersOpen ? ' is-open' : '') + '">';
    // Buscador: por nombre, sabor (tag) o nota (descripción). Match por tokens.
    out += '<div class="byb-search">' +
      '<svg class="byb-search__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2"/><line x1="16.5" y1="16.5" x2="21" y2="21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
      '<input type="search" class="byb-search__input" data-byb-search placeholder="Search by name, flavor, or note" value="' + esc(f.search || '') + '" aria-label="Search chocolates" autocomplete="off">' +
      (f.search ? '<button type="button" class="byb-search__clear" data-byb-search-clear aria-label="Clear search">×</button>' : '') +
    '</div>';
    // Mobile: toggle de filtros (colapsados por defecto → el grid queda a la mano, menos scroll)
    out += '<button type="button" class="byb-filters__toggle" data-byb-filters-toggle aria-expanded="' + (filtersOpen ? 'true' : 'false') + '">Filters</button>';
    out += '<div class="byb-filters__body">';
    // #12: categoría (chocolate/trufa) ARRIBA del type
    out += group('Show',
      chip('category', 'all', 'All', true) + chip('category', 'chocolate', 'Chocolates', true) + chip('category', 'truffle', 'Truffles', true),
      'byb-filter-group--cat');
    // #1: orden por calorías
    out += group('Calories',
      chip('sort', 'cal-asc', 'Low → High', true) + chip('sort', 'cal-desc', 'High → Low', true));
    // type
    out += group('Type',
      Object.keys(TYPE_LABELS).map(function (k) { return chip('types', k, TYPE_LABELS[k]); }).join(''));
    // include ampliado
    out += group('Include',
      FLAVOR_FILTERS.map(function (o) { return chip('include', o.id, o.label); }).join(''));
    // exclude = espejo de include
    out += group('Exclude',
      FLAVOR_FILTERS.map(function (o) { return chip('exclude', o.id, o.label); }).join(''),
      'byb-filter-group--exclude');
    out += '</div>'; // .byb-filters__body
    out += '</div>'; // .byb-filters
    return out;
  }

  function passesFilters(item) {
    var f = state.filters;
    if (f.search) {
      // match "similar": acentos normalizados + tolerancia a plural/typo corto, sobre nombre+tags+descripción
      var hay = searchNorm(item.name + ' ' + (item.tags || []).join(' ') + ' ' + (item.description || ''));
      var toks = searchNorm(f.search).split(/\s+/).filter(Boolean);
      var ok = toks.every(function (tok) {
        if (hay.indexOf(tok) >= 0) return true;
        var t2 = tok.replace(/s$/, '');          // plural simple: truffles → truffle
        return t2.length >= 3 && hay.indexOf(t2) >= 0;
      });
      if (!ok) return false;
    }
    if (f.category !== 'all' && item.category !== f.category) return false;
    if (f.types.length) { var its = typesOf(item); if (!f.types.some(function (t) { return its.indexOf(t) >= 0; })) return false; }
    if (f.include.length && !f.include.some(function (t) { return item.tags.indexOf(t) >= 0; })) return false;
    if (f.exclude.some(function (t) { return item.tags.indexOf(t) >= 0; })) return false;
    return true;
  }

  // ordena por calorías si está activo el sort
  function sortByCalories(arr) {
    if (state.filters.sort === 'cal-asc') return arr.sort(function (a, b) { return (a.calories || 0) - (b.calories || 0); });
    if (state.filters.sort === 'cal-desc') return arr.sort(function (a, b) { return (b.calories || 0) - (a.calories || 0); });
    return arr;
  }

  // #12: grid en secciones Chocolates / Truffles
  function renderCatalogSections(items) {
    if (!catalog.length) {
      return '<p class="byb-empty">We couldn\'t load flavors. Refresh the page, or call any Araya store: Heights, Uptown Park, or Katy.</p>';
    }
    if (!items.length) {
      return '<p class="byb-empty">No flavors match these filters. Clear a filter to see more.</p>';
    }
    var chocs = items.filter(function (i) { return i.category !== 'truffle'; });
    var truffs = items.filter(function (i) { return i.category === 'truffle'; });
    function section(title, arr) {
      if (!arr.length) return '';
      return '<section class="byb-catsection">' +
        '<h3 class="byb-catsection__title">' + title + '<span class="byb-catsection__count">' + arr.length + '</span></h3>' +
        '<div class="byb-grid">' + arr.map(renderCard).join('') + '</div>' +
      '</section>';
    }
    return section('Chocolates', chocs) + section('Truffles', truffs);
  }

  function getTopAttrs(item) {
    // Returns exactly 3 attribute chips ordered by importance.
    // Type first; then strongest tags; fill with negatives ("No nuts", "No alcohol") so the user always sees a 3-attr profile.
    var attrs = [];
    attrs.push({ kind: 'type', label: typeLabel(item) });

    var tags = item.tags || [];
    var priority = ['best_seller', 'spicy', 'alcohol', 'coffee', 'nuts', 'fruit', 'vegan'];
    var positives = priority.filter(function (t) { return tags.indexOf(t) >= 0; });

    positives.forEach(function (t) {
      if (attrs.length < 3) attrs.push({ kind: 'tag', label: TAG_LABELS[t] || t });
    });

    // Fill remaining slots with useful negatives (allergen-friendly signals)
    if (attrs.length < 3 && tags.indexOf('nuts') < 0)    attrs.push({ kind: 'neg', label: 'No nuts' });
    if (attrs.length < 3 && tags.indexOf('alcohol') < 0) attrs.push({ kind: 'neg', label: 'No alcohol' });
    if (attrs.length < 3 && tags.indexOf('coffee') < 0)  attrs.push({ kind: 'neg', label: 'No coffee' });

    return attrs.slice(0, 3);
  }

  function renderCard(item) {
    var qty = getQty(item.id);
    var canAdd = totalQty() < state.size;
    var hasQty = qty > 0;
    var isBest = (item.tags || []).indexOf('best_seller') >= 0;
    var isOOS = !!item.out_of_stock;
    // Meta del grid: tipo (con "&" si doble) + sabores REALES (sin best_seller). Limpio y corto.
    var metaParts = [];
    var tlabel = typeLabel(item);
    if (tlabel) metaParts.push(tlabel);
    (item.tags || []).forEach(function (t) {
      if (t !== 'best_seller' && TAG_LABELS[t] && metaParts.length < 3) metaParts.push(TAG_LABELS[t]);
    });

    return '<article class="byb-card' + (hasQty ? ' has-qty' : '') + (isOOS ? ' byb-card--oos' : '') + '" data-byb-card-id="' + esc(item.id) + '">' +
      '<button type="button" class="byb-card__media" data-byb-details="' + esc(item.id) + '" aria-label="View details for ' + esc(item.name) + '">' +
        (item.image_url
          ? '<img class="byb-card__img" src="' + esc(safeUrl(item.image_url)) + '" alt="' + esc(item.name) + '" loading="lazy" decoding="async">'
          : '<div class="byb-card__img byb-card__img--placeholder"></div>') +
        (isOOS
          ? '<span class="byb-card__sig byb-card__sig--oos">Out of stock</span>'
          : (isBest ? '<span class="byb-card__sig">Best Seller</span>' : '')) +
      '</button>' +
      '<div class="byb-card__body">' +
        '<button type="button" class="byb-card__name" data-byb-details="' + esc(item.id) + '">' + esc(item.name) + '</button>' +
        // grid: línea de meta ordenada (texto · separado), no chips chunky. Badges con color → solo en popup.
        '<div class="byb-card__meta">' +
          metaParts.map(function (l) { return esc(l); }).join('<span class="byb-card__dot">·</span>') +
        '</div>' +
      '</div>' +
      // #8: sin botón grande "+Add". Stepper discreto siempre visible + "+3" permanente (#6).
      '<div class="byb-card__qty">' +
        '<button type="button" class="byb-qstep" data-byb-qty-dec="' + esc(item.id) + '" ' + (hasQty ? '' : 'disabled') + ' aria-label="Remove one">−</button>' +
        '<span class="byb-qstep__n">' + qty + '</span>' +
        '<button type="button" class="byb-qstep" data-byb-qty-inc="' + esc(item.id) + '" ' + (canAdd && !isOOS ? '' : 'disabled') + ' aria-label="Add one">+</button>' +
        '<button type="button" class="byb-qstep byb-qstep--bulk" data-byb-qty-bulk="' + esc(item.id) + '" data-byb-qty-bulk-amt="3" ' + (canAdd && !isOOS ? '' : 'disabled') + ' aria-label="Add three">+3</button>' +
      '</div>' +
    '</article>';
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // ---------- Events ----------
  function bindEvents() {
    document.addEventListener('click', function (ev) {
      // Modal close (lives outside #byb-root, listener on document catches it)
      var t = ev.target.closest('[data-byb-modal-close]');
      if (t) return closeDetailsModal();

      t = ev.target.closest('[data-byb-help-toggle]');
      if (t) return toggleHelp();

      t = ev.target.closest('[data-byb-help-dismiss]');
      if (t) return dismissHelp();

      t = ev.target.closest('[data-byb-filters-toggle]');
      if (t) {
        filtersOpen = !filtersOpen;
        var fb = document.querySelector('.byb-filters');
        if (fb) fb.classList.toggle('is-open', filtersOpen);
        t.setAttribute('aria-expanded', filtersOpen ? 'true' : 'false');
        return;
      }

      t = ev.target.closest('[data-byb-size]');
      if (t) return onSizeSelect(parseInt(t.dataset.bybSize, 10));

      t = ev.target.closest('[data-byb-color]');
      if (t) return onColorSelect(t.dataset.bybColor);

      t = ev.target.closest('[data-byb-back]');
      if (t) return onBack();

      t = ev.target.closest('[data-byb-goto]');
      if (t && !t.disabled) return goto(parseInt(t.dataset.bybGoto, 10));

      t = ev.target.closest('[data-byb-qty-inc]');
      if (t && !t.disabled) return onQtyInc(t.dataset.bybQtyInc);

      t = ev.target.closest('[data-byb-qty-dec]');
      if (t && !t.disabled) return onQtyDec(t.dataset.bybQtyDec);

      t = ev.target.closest('[data-byb-qty-bulk]');
      if (t && !t.disabled) return onQtyBulk(t.dataset.bybQtyBulk, parseInt(t.dataset.bybQtyBulkAmt, 10) || 1);

      t = ev.target.closest('[data-byb-filter]');
      if (t) return onFilterToggle(t.dataset.bybFilter, t.dataset.bybFilterVal, t.dataset.bybSingle === '1');

      t = ev.target.closest('[data-byb-search-clear]');
      if (t) return clearSearch();

      t = ev.target.closest('[data-byb-clear]');
      if (t) return onClearAll();

      t = ev.target.closest('[data-byb-confirm-yes]');
      if (t) { doClearItems(); return closeClearConfirm(); }

      t = ev.target.closest('[data-byb-confirm-cancel]');
      if (t) return closeClearConfirm();

      t = ev.target.closest('[data-byb-add]');
      if (t && !t.disabled) return onAddToCart();

      t = ev.target.closest('[data-byb-details]');
      if (t) return openDetailsModal(t.dataset.bybDetails);

      t = ev.target.closest('[data-byb-toggle-selection]');
      if (t) return togglePanel();
    });

    // Búsqueda en vivo (evento input, separado del click).
    document.addEventListener('input', function (ev) {
      var s = ev.target.closest('[data-byb-search]');
      if (s) onSearchInput(s.value);
    });
    document.addEventListener('change', function (ev) {
      var d = ev.target.closest('[data-byb-date]');
      if (!d) return;
      // El datepicker custom ya bloquea domingos; guardamos lo elegido.
      state.deliverBy = bybIsWeekend(d.value) ? '' : d.value;
    });
  }

  function togglePanel() {
    panelExpanded = !panelExpanded;
    var aside = document.querySelector('[data-byb-selection]');
    if (aside) aside.classList.toggle('is-expanded', panelExpanded);
    var handle = document.querySelector('[data-byb-toggle-selection]');
    if (handle) handle.setAttribute('aria-expanded', panelExpanded ? 'true' : 'false');
  }

  // ---------- Details modal ----------
  // #8: en el POPUP los badges sí van con color distintivo (type + tags).
  function badgeList(item) {
    var out = [];
    var ts = typesOf(item);
    if (ts.length > 1) out.push({ key: 'mixed', label: typeLabel(item) });          // doble → 1 badge neutro "Milk & Dark"
    else if (ts.length === 1) out.push({ key: ts[0], label: TYPE_LABELS[ts[0]] || ts[0] });
    (item.tags || []).forEach(function (t) { out.push({ key: t, label: TAG_LABELS[t] || t }); });
    return out;
  }
  function badgesHtml(item) {
    return badgeList(item).map(function (b) {
      return '<span class="byb-badge byb-badge--' + esc(b.key) + '">' + esc(b.label) + '</span>';
    }).join('');
  }

  var lastFocused = null;
  var confirmLastFocused = null;
  function openDetailsModal(id) {
    closeDetailsModal();
    var c = chocoById(id);
    if (!c) return;
    lastFocused = document.activeElement;
    var modal = document.createElement('div');
    modal.className = 'byb-modal';
    modal.setAttribute('data-byb-modal', '');
    modal.innerHTML =
      '<div class="byb-modal__backdrop" data-byb-modal-close></div>' +
      '<div class="byb-modal__content" role="dialog" aria-modal="true" aria-labelledby="byb-modal-title">' +
        '<button type="button" class="byb-modal__close" data-byb-modal-close aria-label="Close">×</button>' +
        (c.image_url
          ? '<img class="byb-modal__img" src="' + esc(safeUrl(c.image_url)) + '" alt="' + esc(c.name) + '" decoding="async">'
          : '<div class="byb-modal__img byb-modal__img--placeholder"></div>') +
        '<div class="byb-modal__body">' +
          '<div class="byb-modal__badges">' + badgesHtml(c) + '</div>' +
          '<h3 id="byb-modal-title" class="byb-modal__title">' + esc(c.name) + '</h3>' +
          (c.calories ? '<div class="byb-modal__cal">' + c.calories + ' cal each</div>' : '') +
          (c.description ? '<p class="byb-modal__desc">' + esc(c.description) + '</p>' : '') +
          '<div class="byb-modal__actions" data-byb-modal-actions>' +
            renderModalActions(c.id) +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);
    document.body.classList.add('byb-modal-open');
    requestAnimationFrame(function () { modal.classList.add('is-show'); });
    document.addEventListener('keydown', escHandler);
    var closeBtn = modal.querySelector('.byb-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function renderModalActions(id) {
    var qty = getQty(id);
    var canAdd = totalQty() < state.size;
    if (qty > 0) {
      return '<button type="button" class="byb-qty-btn" data-byb-qty-dec="' + esc(id) + '" aria-label="Remove one">−</button>' +
        '<span class="byb-qty-num">' + qty + '</span>' +
        '<button type="button" class="byb-qty-btn" data-byb-qty-inc="' + esc(id) + '" ' + (canAdd ? '' : 'disabled') + ' aria-label="Add one">+</button>';
    }
    return '<button type="button" class="byb-btn byb-btn--primary" data-byb-qty-inc="' + esc(id) + '" ' + (canAdd ? '' : 'disabled') + '>+ Add to box</button>';
  }

  function syncModal() {
    var modal = document.querySelector('.byb-modal');
    if (!modal) return;
    var actions = modal.querySelector('[data-byb-modal-actions]');
    if (!actions) return;
    var ref = actions.querySelector('[data-byb-qty-inc],[data-byb-qty-dec]');
    var id = ref && (ref.dataset.bybQtyInc || ref.dataset.bybQtyDec);
    if (!id) return;
    actions.innerHTML = renderModalActions(id);
  }

  function escHandler(e) {
    if (e.key === 'Escape') return closeDetailsModal();
    var content = document.querySelector('.byb-modal:not(.byb-modal--confirm) .byb-modal__content');
    if (content) trapFocus(content, e);
  }

  // Atrapa Tab/Shift+Tab dentro del contenedor del modal (WCAG 2.4.3 / 2.1.2).
  function trapFocus(container, e) {
    if (e.key !== 'Tab') return;
    var f = container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    f = Array.prototype.filter.call(f, function (el) { return !el.disabled && el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function closeDetailsModal() {
    var m = document.querySelector('.byb-modal:not(.byb-modal--confirm)');
    if (!m) return;
    m.classList.remove('is-show');
    document.body.classList.remove('byb-modal-open');
    setTimeout(function () { if (m && m.parentNode) m.remove(); }, 200);
    document.removeEventListener('keydown', escHandler);
    if (lastFocused && lastFocused.focus) { try { lastFocused.focus(); } catch (e) {} }
  }

  function onSizeSelect(n) {
    state.size = n;
    prefetchColorImages(n); // perf: precarga las 3 fotos de caja del size elegido (paso 2)
    // L5 fix: NO recortamos FIFO. Si la nueva caja es más pequeña que lo ya
    // elegido, conservamos la selección y dejamos que el cliente decida QUÉ
    // quitar (el CTA muestra "Remove X" y los "+" se deshabilitan hasta cuadrar).
    var over = totalQty() - n;
    if (over > 0) {
      toast('This box holds ' + n + '. Remove ' + over + ' to continue.');
    }
    persistDraft();
    state.step = state.color ? 3 : 2;
    render();
    focusStepStart();
  }

  function onColorSelect(c) {
    state.color = c;
    persistDraft();
    state.step = 3;
    render();
    focusStepStart();
  }

  function onBack() {
    if (state.step > 1) state.step -= 1;
    render();
    focusStepStart();
  }

  function goto(n) {
    state.step = n;
    render();
    focusStepStart();
  }

  // Perf: precarga las 3 fotos de caja del size elegido para que el paso 2 ya las tenga en cache.
  function prefetchColorImages(n) {
    var imgs = COLOR_IMAGES_BY_SIZE[n] || {};
    Object.keys(imgs).forEach(function (k) {
      try { var im = new Image(); im.decoding = 'async'; im.src = safeUrl(imgs[k]); } catch (e) {}
    });
  }

  // a11y: al cambiar de paso el innerHTML se reemplaza y el foco caería al <body>.
  // Lo movemos al inicio del nuevo paso (heading, o el contador de progreso en el paso 3)
  // para que el teclado no pierda la posición y el lector anuncie el nuevo contexto.
  function focusStepStart() {
    var el = root.querySelector('.byb-h2') || root.querySelector('.byb-progress__count');
    if (el) { el.setAttribute('tabindex', '-1'); try { el.focus(); } catch (e) {} }
  }

  // Render NO destructivo: en cada +/- NO reconstruimos el grid (38 cards).
  // Parcheamos in place los nodos vivos → se preserva el foco y no hay jank (a11y + smoothness).
  function patchStep3() {
    if (state.step !== 3) return;
    var size = state.size || 0;
    var total = totalQty();
    var canAdd = total < size;

    // 1) cada card del grid: contador + estado disabled + highlight, sin re-render
    var cards = root.querySelectorAll('.byb-card[data-byb-card-id]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var id = card.getAttribute('data-byb-card-id');
      var qty = getQty(id);
      card.classList.toggle('has-qty', qty > 0);
      var n = card.querySelector('.byb-qstep__n'); if (n) n.textContent = qty;
      var dec = card.querySelector('[data-byb-qty-dec]'); if (dec) dec.disabled = qty <= 0;
      var inc = card.querySelector('[data-byb-qty-inc]'); if (inc) inc.disabled = !canAdd;
      var bulk = card.querySelector('[data-byb-qty-bulk]'); if (bulk) bulk.disabled = !canAdd;
    }
    // 2) progreso (count tiene aria-live → se anuncia)
    var pc = root.querySelector('.byb-progress__count'); if (pc) pc.textContent = total + '/' + size + ' pieces';
    var bar = root.querySelector('.byb-progress__bar'); if (bar) bar.setAttribute('aria-valuenow', total);
    var fill = root.querySelector('.byb-progress__fill'); if (fill) fill.style.width = (size ? Math.min(100, Math.round((total / size) * 100)) : 0) + '%';
    // 3) valor "Chocolates" del stepper
    var vals = root.querySelectorAll('.byb-step .byb-step__val');
    if (vals[2]) vals[2].textContent = size ? (total + ' / ' + size) : '';
    // 4) panel de selección (pequeño → re-render OK). Preservamos el foco del teclado:
    //    si el botón enfocado vivía en el panel, lo re-enfocamos tras reconstruirlo (a11y).
    var aside = root.querySelector('[data-byb-selection]');
    if (aside) {
      var active = document.activeElement, focusSel = null;
      if (active && aside.contains(active)) {
        var incId = active.getAttribute && active.getAttribute('data-byb-qty-inc');
        var decId = active.getAttribute && active.getAttribute('data-byb-qty-dec');
        if (incId) focusSel = '[data-byb-qty-inc="' + cssEsc(incId) + '"]';
        else if (decId) focusSel = '[data-byb-qty-dec="' + cssEsc(decId) + '"]';
        else if (active.hasAttribute('data-byb-toggle-selection')) focusSel = '[data-byb-toggle-selection]';
        else if (active.hasAttribute('data-byb-clear')) focusSel = '[data-byb-clear]';
      }
      aside.innerHTML = renderSelectionPanel();
      if (focusSel) { var rf = aside.querySelector(focusSel); if (rf) { try { rf.focus(); } catch (e) {} } }
    }
    // 5) TODAS las CTA (header + panel sticky): texto + disabled
    var ctas = root.querySelectorAll('[data-byb-add]');
    for (var j = 0; j < ctas.length; j++) {
      ctas[j].textContent = ctaTextFor(total, size);
      ctas[j].disabled = (total !== size);
    }
  }

  function isOutOfStock(id) {
    var it = catalog.find(function (c) { return c.id === id; });
    return !!(it && it.out_of_stock);
  }
  function onQtyInc(id) {
    if (isOutOfStock(id)) return;
    if (totalQty() >= state.size) return;
    setQty(id, getQty(id) + 1);
    patchStep3();
    syncModal();
  }
  function onQtyDec(id) {
    setQty(id, Math.max(0, getQty(id) - 1));
    patchStep3();
    syncModal();
  }
  function onQtyBulk(id, amount) {
    if (isOutOfStock(id)) return;
    var room = state.size - totalQty();
    var add = Math.min(amount, room);
    if (add <= 0) return;
    setQty(id, getQty(id) + add);
    patchStep3();
    syncModal();
  }

  function onFilterToggle(group, val, single) {
    var f = state.filters;
    if (single) {
      if (group === 'sort') { f.sort = (f.sort === val) ? '' : val; } // re-click apaga
      else { f.category = val; }                                       // categoría: siempre fija
    } else {
      var arr = f[group];
      var i = arr.indexOf(val);
      if (i >= 0) arr.splice(i, 1); else arr.push(val);
    }
    // preserva el foco/caret del buscador si el usuario tocó un chip mientras escribía
    var keepSearch = document.activeElement && document.activeElement.hasAttribute && document.activeElement.hasAttribute('data-byb-search');
    render();
    if (keepSearch) {
      var inp = root.querySelector('[data-byb-search]');
      if (inp) { try { inp.focus(); var L = inp.value.length; inp.setSelectionRange(L, L); } catch (e) {} }
    }
  }

  // Búsqueda: re-renderiza SOLO el grid (no el paso entero) para no perder el foco del input.
  function onSearchInput(val) {
    state.filters.search = val;
    var cat = root.querySelector('.byb-catalog');
    if (cat) cat.innerHTML = renderCatalogSections(sortByCalories(catalog.filter(passesFilters)));
    var wrap = root.querySelector('.byb-search');
    if (!wrap) return;
    var clearBtn = wrap.querySelector('[data-byb-search-clear]');
    if (val && !clearBtn) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'byb-search__clear';
      b.setAttribute('data-byb-search-clear', ''); b.setAttribute('aria-label', 'Clear search');
      b.textContent = '×';
      wrap.appendChild(b);
    } else if (!val && clearBtn) {
      clearBtn.parentNode.removeChild(clearBtn);
    }
  }
  function clearSearch() {
    state.filters.search = '';
    var input = root.querySelector('[data-byb-search]');
    if (input) { input.value = ''; }
    onSearchInput('');
    if (input) input.focus();
  }

  // #9: Clear all — confirma si la caja está >40% llena
  function onClearAll() {
    if (totalQty() === 0) return;
    var pct = state.size ? (totalQty() / state.size) : 0;
    if (pct > 0.4) { openClearConfirm(); return; }
    doClearItems();
  }
  function doClearItems() {
    state.items = [];
    persistDraft();
    render();
  }
  function openClearConfirm() {
    closeClearConfirm();
    var m = document.createElement('div');
    m.className = 'byb-modal byb-modal--confirm';
    m.innerHTML =
      '<div class="byb-modal__backdrop" data-byb-confirm-cancel></div>' +
      '<div class="byb-confirm" role="dialog" aria-modal="true" aria-labelledby="byb-confirm-title">' +
        '<h3 id="byb-confirm-title" class="byb-confirm__title">Clear your box?</h3>' +
        '<p class="byb-confirm__text">You\'ve picked ' + totalQty() + ' of ' + state.size + ' chocolates. This removes all of them.</p>' +
        '<div class="byb-confirm__actions">' +
          '<button type="button" class="byb-btn byb-btn--ghost" data-byb-confirm-cancel>Keep them</button>' +
          '<button type="button" class="byb-btn byb-btn--danger" data-byb-confirm-yes>Yes, clear all</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(m);
    document.body.classList.add('byb-modal-open');
    requestAnimationFrame(function () { m.classList.add('is-show'); });
    confirmLastFocused = document.activeElement;
    document.addEventListener('keydown', confirmKeyHandler);
    var yes = m.querySelector('[data-byb-confirm-yes]');
    if (yes) yes.focus();
  }
  function confirmKeyHandler(e) {
    if (e.key === 'Escape') return closeClearConfirm();
    var c = document.querySelector('.byb-modal--confirm .byb-confirm');
    if (c) trapFocus(c, e);
  }
  function closeClearConfirm() {
    var m = document.querySelector('.byb-modal--confirm');
    if (!m) return;
    m.classList.remove('is-show');
    document.body.classList.remove('byb-modal-open');
    setTimeout(function () { if (m && m.parentNode) m.remove(); }, 200);
    document.removeEventListener('keydown', confirmKeyHandler);
    if (confirmLastFocused && confirmLastFocused.focus) { try { confirmLastFocused.focus(); } catch (e) {} }
  }

  // ---------- Add to cart ----------
  function onAddToCart() {
    if (adding) return;                       // C1: ignora doble-tap mientras hay un POST en vuelo
    if (totalQty() !== state.size) return;
    var variantId = cfg.variants[state.size];
    // Formato legible para COCINA en carrito/checkout/admin/email: "2× Name / 1× Name".
    // SIN _chocolates_json → no aparece JSON feo en el admin/data de Shopify ni en el correo.
    // La edición re-parsea esta misma string (parseChocolatesProp), así que no se pierde nada.
    var humanList = state.items.map(function (it) {
      var c = chocoById(it.id);
      return it.qty + '× ' + (c ? c.name : it.id);
    }).join(' / ');

    // _size va OCULTO (prefijo _) para no duplicar la opción "Size" de la variante,
    // que Shopify ya muestra nativamente en cart/checkout/admin. La cocina ve el
    // tamaño por la variante; _size queda solo como respaldo para la edición.
    var properties = {
      _box_id: state.boxId,
      _size: state.size + ' pieces',
      'Color': labelFor(COLORS, state.color),
      'Chocolates': humanList
    };
    if (state.deliverBy && !bybIsWeekend(state.deliverBy)) {
      properties['Needed by'] = 'A specific date';
      properties['Deliver by'] = state.deliverBy;
    } else {
      properties['Needed by'] = 'As soon as possible';
    }

    if (!variantId) {
      console.warn('[BYB] No real variant_id (demo mode). Payload:', { id: 'DEMO', properties: properties });
      alert('DEMO: box ready to add. In production this goes to cart.\n\n' + humanList);
      return;
    }

    var addBody = { id: variantId, quantity: 1, properties: properties };

    adding = true;
    setAddDisabled(true);
    fetch(cfg.cartRoute, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(addBody)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart add failed: ' + r.status);
        return r.json();
      })
      .then(function () {
        // L4: transacción — solo AHORA (add nuevo OK) borramos la caja original,
        // por su line-key exacto (robusto ante el _box_id ahora duplicado).
        if (state.editLineKey) return removeOldLine(state.editLineKey);
      })
      .then(function () {
        clearDraft();
        return playAddSuccess(); // animación placentera antes de ir al carrito
      })
      .then(function () {
        window.location.href = '/cart'; // navega → no reseteamos adding (la página se va)
      })
      .catch(function (err) {
        console.error('[BYB] Add to cart error:', err);
        toast('Could not add the box. Please try again.');
        adding = false;
        setAddDisabled(false);
      });
  }

  // Deshabilita/rehabilita todas las CTA de add mientras el POST está en vuelo (C1).
  function setAddDisabled(on) {
    if (!root) return;
    var ctas = root.querySelectorAll('[data-byb-add]');
    for (var i = 0; i < ctas.length; i++) ctas[i].disabled = on || (totalQty() !== state.size);
  }

  // Animación de éxito al agregar al carrito: círculo + checkmark dibujado, luego redirige.
  function playAddSuccess() {
    return new Promise(function (resolve) {
      var ov = document.createElement('div');
      ov.className = 'byb-success';
      ov.setAttribute('role', 'status');
      ov.innerHTML =
        '<div class="byb-success__card">' +
          '<svg class="byb-success__check" viewBox="0 0 52 52" aria-hidden="true">' +
            '<circle class="byb-success__circle" cx="26" cy="26" r="24" fill="none"/>' +
            '<path class="byb-success__mark" fill="none" d="M14.5 27l7.5 7.5 15.5-16"/>' +
          '</svg>' +
          '<div class="byb-success__text">Added to your cart</div>' +
        '</div>';
      document.body.appendChild(ov);
      document.body.classList.add('byb-modal-open'); // congela el scroll de fondo durante la animación
      requestAnimationFrame(function () { ov.classList.add('is-show'); });
      // fallback: si el redirect a /cart falla/demora, no dejar el overlay colgado tapando la UI
      setTimeout(function () {
        if (ov.parentNode) { ov.parentNode.removeChild(ov); document.body.classList.remove('byb-modal-open'); }
      }, 3000);
      setTimeout(resolve, 900);
    });
  }

  function removeOldLine(lineKey) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    }).then(function (r) {
      // Si el remove falla, NO abortamos: la caja nueva ya entró al carrito. Solo lo
      // registramos para no perder la venta por un cambio de line-key tras el add.
      if (!r.ok) console.warn('[BYB] No se pudo eliminar la línea original al editar:', lineKey);
    });
  }

  // ---------- Toast ----------
  function toast(msg) {
    var el = document.createElement('div');
    el.className = 'byb-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.textContent = msg;
    document.body.appendChild(el);
    setTimeout(function () { el.classList.add('is-show'); }, 10);
    setTimeout(function () {
      el.classList.remove('is-show');
      setTimeout(function () { el.remove(); }, 300);
    }, 3500);
  }

  // ---------- Boot ----------
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // bfcache: al volver con "Atrás" del navegador, la página puede restaurarse con DOM/estado
  // viejos (p. ej. una caja ya borrada del carrito) y los botones quedan inertes hasta refrescar.
  // Forzamos un reload limpio para reconstruir el builder desde el draft real de localStorage.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) window.location.reload();
  });
})();
